import { Gem, Plus, Activity } from "lucide-react";
import { Button } from "@/components/ui/button";

export const Header = ({ onInject, nowUtc }) => {
  return (
    <header className="sticky top-0 z-50 glass border-b border-[#232D40]" data-testid="vault-header">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-3 flex items-center justify-between gap-4">
        <div className="flex items-center gap-3">
          <div className="h-10 w-10 rounded-xl flex items-center justify-center bg-gradient-to-br from-amber-400 to-amber-600 shadow-[0_0_20px_rgba(245,158,11,0.35)]">
            <Gem className="h-5 w-5 text-[#0B0E17]" strokeWidth={2.4} />
          </div>
          <div>
            <h1 className="font-display text-xl sm:text-2xl font-bold tracking-wide leading-none text-amber-400">
              AUREON VAULT
            </h1>
            <p className="text-[11px] text-slate-400 font-mono-data tracking-wider mt-0.5">
              AUREON TRADER · SPENCER FIRM LEDGER
            </p>
          </div>
        </div>
        <div className="flex items-center gap-3">
          <div className="hidden sm:flex items-center gap-2 px-3 py-1.5 rounded-lg bg-emerald-500/10 border border-emerald-500/20">
            <Activity className="h-3.5 w-3.5 text-emerald-400" />
            <span className="text-xs font-mono-data text-emerald-400">{nowUtc} UTC</span>
          </div>
          <Button
            data-testid="open-inject-btn"
            onClick={onInject}
            className="bg-amber-500 hover:bg-amber-400 text-[#0B0E17] font-semibold rounded-lg transition-colors"
          >
            <Plus className="h-4 w-4 mr-1.5" strokeWidth={2.6} />
            Log Tranche
          </Button>
        </div>
      </div>
    </header>
  );
};
